// extracted by mini-css-extract-plugin
export default {"formBody":"FormBody_formBody__kKRip"};